import gql from 'graphql-tag';

export const REFRESH_FACEBOOK_ACCOUNTS_MUTATION = gql`
  mutation RefreshFacebookAccounts {
    refreshFacebookAccounts {
      facebookAccounts {
        id
      }
      errors
    }
  }
`;
